import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Dashboard from './pages/Dashboard';
import BundleEditor from './pages/BundleEditor';

// Extend the theme to customize for our needs
const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.50',
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
    },
    Table: {
      variants: {
        simple: {
          th: {
            borderColor: 'gray.200',
            backgroundColor: 'gray.50',
          },
          td: {
            borderColor: 'gray.100',
          },
        },
      },
    },
  },
});

// Initialize React application based on the current admin page
const initializeAdmin = () => {
  const dashboardRoot = document.getElementById('qbnd-dashboard-root');
  const editorRoot = document.getElementById('qbnd-editor-root');

  if (dashboardRoot) {
    createRoot(dashboardRoot).render(
      <ChakraProvider theme={theme}>
        <Dashboard />
      </ChakraProvider>
    );
  }

  if (editorRoot) {
    createRoot(editorRoot).render(
      <ChakraProvider theme={theme}>
        <BundleEditor />
      </ChakraProvider>
    );
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeAdmin);